import { FC } from 'react';
import {
    AutocompleteInput,
    Datagrid,
    DatagridProps,
    DateField,
    DateInput,
    List,
    ListContextProvider,
    ListProps,
    NumberField,
    // ReferenceInput,
    TextField,
    TextInput,
    useListContext,
    ReferenceField,
    // NumberInput,
    Pagination,
    PaginationProps,
    SelectField,
    EmailField,
    BulkExportButton,
    BulkActionsToolbarProps,
    // FunctionField,
} from 'react-admin';

import { makeStyles } from '@material-ui/core/styles';
import {
    CurrencyFormatInput,
    dateLocales,
    defaultDateOptions
} from '../utils/formatters';

import { Box, InputAdornment } from '@material-ui/core';
import ListActions from '../components/ToolbarActions';
import { getOffersStatuses } from './OffersTypes';
import { SearchOutlined } from '@material-ui/icons';
import { BulkCopyClipboard } from '../components/BulkActions';
import BulkChangeStatus from './BulkChangeStatus';

const offersStatuses = getOffersStatuses()

const financingFilters = [
    <TextInput
        source="id"
        alwaysOn
        style={{
            minWidth: '400px', //TODO: responsive
        }}
        InputProps={{
            endAdornment: (
                <InputAdornment position="end">
                    <SearchOutlined />
                </InputAdornment>
            ),
        }}
    />,
    // <ReferenceInput
    //     source="merchant_id"
    //     reference="merchants"
    //     sort={{ field: 'email', order: 'ASC' }}
    //     alwaysOn
    //     label="resources.offers.fields.email"
    //     perPage={10}
    //     filterToQuery={email => ({ email })}
    // >
    //     <AutocompleteInput
    //         optionText="email"
    //         resettable
    //     />
    // </ReferenceInput>,
    <TextInput
        // optionText="email"
        source="merchant#email@_ilike"
        resettable
        alwaysOn
    />,
    // <ReferenceInput
    //     source="merchant_id"
    //     reference="merchants"
    //     sort={{ field: 'name', order: 'ASC' }}
    //     alwaysOn
    //     label="resources.offers.fields.name"
    //     perPage={10}
    //     filterToQuery={name => ({ name })}
    // >
    //     <AutocompleteInput
    //         optionText="name"
    //         resettable
    //     />
    // </ReferenceInput>,
    <TextInput
        // optionText="email"
        source="merchant#name@_ilike"
        resettable
        alwaysOn
    />,
    <AutocompleteInput source="status" choices={offersStatuses} resettable alwaysOn />,
    //  <SearchInput source="name" alwaysOn />,
    <DateInput source="created_at@_gte" label="resources.common.fields.created_at@_gte" />,
    <DateInput source="created_at@_lte" label="resources.common.fields.created_at@_lte" />,
    <DateInput source="updated_at@_gte" label="resources.common.fields.updated_at@_gte" />,
    <DateInput source="updated_at@_lte" label="resources.common.fields.updated_at@_lte" />,
    <TextInput
        source="amount@_gte"
        InputProps={{
            inputComponent: CurrencyFormatInput,
        }}
    />,
    <TextInput
        source="amount@_lte"
        InputProps={{
            inputComponent: CurrencyFormatInput,
        }}
    />,
    // <SelectInput source="country" choices={countries} />,
    // <TextInput
    //     source="fixed_fee"
    //     format={(v: number) => v / 100}
    //     parse={(v: string) => parseFloat(v) * 100}
    //     InputProps={{
    //         inputComponent: PercentFormatInput,
    //     }}

    // />,
    // <TextInput
    //     source="repayment_rate"
    //     format={(v: number) => v / 100}
    //     parse={(v: string) => parseFloat(v) * 100}
    //     InputProps={{
    //         inputComponent: PercentFormatInput,
    //     }}
    // />,
    // <SelectInput source="currency" choices={listCurrencies} />,
]

const useDatagridStyles = makeStyles(theme => ({
    amount: {},
    fixed_fee: {},
    email: { color: theme.palette.text.primary },
}));

interface TabbedDatagridProps extends DatagridProps { }

const ListDatagrid: FC<TabbedDatagridProps> = props => {
    const listContext = useListContext();
    // const { ids, filterValues, setFilters, displayedFilters } = listContext;
    const classes = useDatagridStyles();


    return (
        <ListContextProvider
            value={{ ...listContext }}
        >
            <Datagrid {...props} optimized rowClick="edit">
                <NumberField source="id" label="resources.common.fields.id" />
                <DateField source="created_at" label="resources.common.fields.created_at" locales={dateLocales} options={defaultDateOptions} showTime />
                <DateField source="updated_at" label="resources.common.fields.updated_at" locales={dateLocales} options={defaultDateOptions} showTime />
                <ReferenceField source="merchant_id" reference="merchants">
                    <TextField source="id" />
                </ReferenceField>
                {/* <CustomNumberField
                    source="amount"
                    divisor={100}
                    className={classes.amount}
                    locales="en-US"
                    options={currencyFormatter().resolvedOptions()}
                /> */}
                {/* <ReferenceField source="platform_id" reference="Platform">
                    <ColoredChipField size="small" source="name" />
                </ReferenceField> */}
                {/* <ChipField source="country" variant="outlined" size="small" color="primary" /> */}
                {/* <TextField source="currency" /> */}
                {/* <CustomNumberField
                    source="fixed_fee"
                    divisor={10000}
                    className={classes.amount}
                    locales="en-US"
                    options={percentFormatter().resolvedOptions()}
                /> */}
                {/* <CustomNumberField
                    source="repayment_rate"
                    divisor={10000}
                    className={classes.amount}
                    locales="en-US"
                    options={percentFormatter().resolvedOptions()}
                /> */}
                {/* <DateField source="financing_date" locales={dateLocales} options={defaultDateOptions} /> */}
                {/* <DateField source="limit_date" locales={dateLocales} options={defaultDateOptions} /> */}
                <ReferenceField source="merchant_id" reference="merchants" label="resources.offers.fields.email" link={false}>
                    <EmailField source="email" className={classes.email} />
                </ReferenceField>
                <SelectField source="status" choices={offersStatuses} />
                {/* <ColoredChipField source="status" size="small" variant="outlined" choices={offersStatuses} /> */}
                {/* <ColoredChipField source="type" size="small" choices={financingTypes} /> */}
            </Datagrid>
        </ListContextProvider>
    );
};

const BulkActionButtons = (props: BulkActionsToolbarProps) => {

    return <>
        <BulkCopyClipboard />
        <BulkExportButton />
        <BulkChangeStatus />
    </>
}

const FinancingList: FC<ListProps> = props => {
    const CustomPagination = (props: JSX.IntrinsicAttributes & PaginationProps) =>
        <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

    return (
        <List
            {...props}
            component={Box}
            actions={<ListActions importer={false} />}
            bulkActionButtons={<BulkActionButtons />}
            sort={{ field: 'updated_at', order: 'DESC' }}
            pagination={<CustomPagination />}
            filters={financingFilters}
            perPage={50}
        >
            <ListDatagrid />
        </List>
    )
}

export default FinancingList;
